"use client";

import { Avatar, AvatarGroup } from "@chakra-ui/react";

const AvatarGroupClient = () => {
  return (
    <AvatarGroup max={4}>
      <Avatar width="48px" height="48px" src="/assets/images/avatar_08.png" />
      <Avatar width="48px" height="48px" src="/assets/images/avatar_07.png" />
      <Avatar width="48px" height="48px" src="/assets/images/avatar_02.png" />
      <Avatar width="48px" height="48px" src="/assets/images/avatar_04.png" />
    </AvatarGroup>
  );
};

export default AvatarGroupClient;
